import './bootstrap';
import Alpine from 'alpinejs';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css'

window.Alpine = Alpine;
Alpine.start();

/* Fallback: define nrReady se não existir (evita ReferenceError) */
window.nrReady = window.nrReady || (fn => {
  if (window.newrelic && typeof window.newrelic.addPageAction === 'function') return fn();
  document.addEventListener('DOMContentLoaded', () => {
    if (window.newrelic) fn();
  });
});

/* Chamada segura ao New Relic */
nrReady(() => {
  const nr = window.newrelic;

  // Sugestão: usar um identificador de build real
  // Configure em .env: VITE_APP_BUILD=abcdef (ou git short sha)
  nr.addRelease('allepets', 'prod', import.meta.env.VITE_APP_BUILD || 'local');

  // Se retornar true, você impede o NR de reportar; false deixa reportar.
  nr.setErrorHandler((err) => {
    console.warn('[NR setErrorHandler]', err);
    return false; // mantém o report padrão
  });

  nr.addPageAction('checkout_open');
});


/* ============================
   CHAT REALTIME (Echo + Alpine)
   ============================ */

function setupChatRealtime() {
  // Procura um container de mensagens na página
  const list = document.getElementById('mensagens');
  if (!list) return; // não é a página do chat

  const conversaId = Number(list.dataset.conversaId || 0);
  if (!conversaId || !window.Echo) return;

  // Evita duplicar listeners em navegações suaves (Livewire/Alpine/etc.)
  try { window.Echo.leave(`private-chat.${conversaId}`); } catch (_) {}

  const ch = window.Echo.private(`chat.${conversaId}`);

  // Remove qualquer listener anterior desse evento
  ch.stopListening('.NovaMensagemEnviada');

  ch.listen('.NovaMensagemEnviada', (e) => {
    // e = { id, conversa_id, mensagem, remetente_id, remetente_nome, created_at }
    if (!e || Number(e.conversa_id) !== conversaId) return;

    // de-dup (já existe esse id na lista?)
    if (list.querySelector(`[data-msg-id="${e.id}"]`)) return;

    const li = document.createElement('li');
    li.className = 'mb-2';
    li.dataset.msgId = e.id;

    li.innerHTML = `
      <strong>${escapeHtml(e.remetente_nome || 'Usuário')}:</strong>
      <span class="text-body">${escapeHtml(e.mensagem)}</span>
      <small class="text-muted d-block">${e.created_at}</small>
    `;

    list.appendChild(li);

    // rola para o fim
    try { li.scrollIntoView({ behavior: 'smooth', block: 'end' }); } catch (_) {}
  });

  function escapeHtml(s) {
    return String(s ?? '')
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'",'&#039;');
  }
}

// Inicializa após o DOM pronto
document.addEventListener('DOMContentLoaded', setupChatRealtime);
